import { Backdrop, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export default function StaticLoading({isLoading = false}) {

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: 999999 }}
            open={isLoading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}